import React from 'react'
import PropTypes from 'prop-types'

const MaintenanceMode = ({ title, message, estimatedTime }) => {
  return (
    <div className="maintenance-mode">
      <div className="maintenance-content">
        <div className="maintenance-icon">
          <i className="fa fa-wrench" />
        </div>
        <h1>{title || 'Site Under Maintenance'}</h1>
        <p>{message || 'We are currently performing scheduled maintenance. Please check back soon.'}</p>
        {estimatedTime && (
          <div className="estimated-time">
            <strong>Estimated completion:</strong> {estimatedTime}
          </div>
        )}
        <div className="maintenance-footer">
          <p>Thank you for your patience.</p>
        </div>
      </div>
      <style jsx>{`
        .maintenance-mode {
          display: flex;
          align-items: center;
          justify-content: center;
          min-height: 100vh;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          font-family: 'Open Sans', sans-serif;
          color: white;
          text-align: center;
          padding: 20px;
          box-sizing: border-box;
        }
        
        .maintenance-content {
          max-width: 600px;
          padding: 40px;
          background: rgba(255, 255, 255, 0.1);
          border-radius: 12px;
          backdrop-filter: blur(10px);
          border: 1px solid rgba(255, 255, 255, 0.2);
        }
        
        .maintenance-icon {
          font-size: 4rem;
          margin-bottom: 30px;
          opacity: 0.8;
        }
        
        .maintenance-content h1 {
          font-size: 2.5rem;
          margin-bottom: 20px;
          font-weight: 300;
        }
        
        .maintenance-content p {
          font-size: 1.2rem;
          line-height: 1.6;
          margin-bottom: 20px;
          opacity: 0.9;
        }
        
        .estimated-time {
          background: rgba(255, 255, 255, 0.1);
          padding: 15px;
          border-radius: 8px;
          margin: 20px 0;
          font-size: 1.1rem;
        }
        
        .maintenance-footer {
          margin-top: 30px;
          font-size: 1rem;
          opacity: 0.7;
        }
        
        @media (max-width: 768px) {
          .maintenance-content {
            padding: 30px 20px;
          }
          
          .maintenance-content h1 {
            font-size: 2rem;
          }
          
          .maintenance-content p {
            font-size: 1.1rem;
          }
          
          .maintenance-icon {
            font-size: 3rem;
          }
        }
      `}</style>
    </div>
  )
}

MaintenanceMode.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string,
  estimatedTime: PropTypes.string,
}

export default MaintenanceMode